import { WaterSupplyLeftNavsList } from "../utils/constants";
import { CommonPageUiLayer } from "../components/CommonPageUiLayer";
import AccordionComponent from "../components/AccordionComponent";

const list = [
  {
    question: "What are the key activities of the Department ?",
    answer: (
      <>
        The objective of the Water Ssupply Department, Kolkata Municipal
        Corporation (KMC) is to provide uninterrupted water supply to the
        residents of Kolkata. The key activities undertaken by the department
        are:
        <ol type="a">
          <li>
            Generation: The river Hoogly is the main source of water supply for
            Kol kata. After drawing water from the river, KMC treats the water
            at Indira Gandhi Water Treatment Plant (WTP) of capacity 260 million
            gallons per day at Palta Water Works. Water from this water works is
            sent to Tallah pumping station for temporary storage and onward
            distribution to the City.
          </li>
          <li>
            Distribution: Water supply department has divided the city into 8
            zones based on hydraulic pattern and best engineering practices. The
            seven zones are : North, Central, West, South, Jadavpur Unit(Br. XI
            & Br. XII), S. S. Unit(Br. XIII & XIV), Gardenreach Unit(Br. XV),
            Joka Unit(Br. XVI) and Tube Well (TW). Water is supplied through
            water pipe network to all over the City for ultimate utilisation by
            domestic as well as non-domestic Consumers.
          </li>
          <li>
            Other Works: Water Supply Department also supplies water for
            shipping, supply through tankers, regular use and emergen cy
            handling of maintenance works.
          </li>
        </ol>
      </>
    ),
  },

  {
    question: "How can I get a water supply connection for my new house ?",
    answer: (
      <>
        Different steps for getting water supply connection:
        <ol type="a">
          {[
            "Contact the Assistant Engineer of the local office of the Water Supply Department.",
            "Collect the list of plumbers from the local Section office or you may download the same from the KMC website.",
            "Select a plumber and the plumber will prepare the estimate. The user should apply in the prescribed format (AnnexF) and place it before the Assistant Engineer for sanction.",
            "After sanction, deposit the amount and get connection.",
            "Fee includes Deposit Money, Water Charges, Connection Fees, Road Opening Fees, Road Restoration Fees etc.",
          ].map((item) => (
            <li>{item}</li>
          ))}
        </ol>
      </>
    ),
  },

  {
    question: "Where can I procure the water supply application form ?",
    answer:
      "You can procure the application form available in net from the Headquarters or download it from the internet or take a xerox copy of the form from your plumber.",
  },

  {
    question:
      "What documents are required for submission along with application form ?",
    answer: (
      <>
        Xerox copy of building sanction plan 2. Receipt of the payment of
        building sanction fees
        <ol type="1">
          {[
            "Xerox copy of building sanction plan",
            "Receipt of the payment of building sanction fees",
            "No Objection Certificate from the assessment and collection department",
            "Plumber “Niyog patra”",
            "NOC from landlord (in case of any tenant)",
          ].map((item) => (
            <li>{item}</li>
          ))}
        </ol>
      </>
    ),
  },

  {
    question:
      "Where should I deposit the application form and the required attachments ?",
    answer:
      "Kindly deposit the documents at your concerned Section office. The Section office would inspect your premises, prepare an estimate of expenses and hand over the application form duly signed by the Assistant Engineer to the citizen or his agent i.e. the plumber",
  },

  {
    question: "Where should I make the payment ?",
    answer:
      "You can only make the payment for the water supply connection at eKolkata centre or the KMC Borough office or C.M.O. Building (5, S. N. Banerjee Road, Kolkata 13)",
  },

  {
    question:
      "What would be the components of the water supply connection charges for building construction purposes ?",
    answer:
      "You would be required to pay connection fees, restoration charges and road opening charges. The size of ferrule & connection fees are calculated as per given in the following tables. Building Ferrule Size Upto 1st. storied 10 mm Upto 2nd storied 15 mm Upto 3rd storied 20 mm Upto 4th storied and above 25 mm Sl.No. Particulars Amount(Rs)(For each ferrule connection) 1 If Height of building <= 8.5 meters 4700 2 If Height of building > 8.5 meters and < 14.5 meters 11000 3 If Height of building > 14.5 meters 21000.",
  },

  {
    question:
      "How should I apply for conversion of water connection for building construction into water connection for domestic use ?",
    answer:
      "Kindly submit application form along with a copy of the Occupancy Certificate at the Section office and pay the requisite fees at the head office based on the demand notice. In case you require the same ferrule size as was used in building construction for domestic use, then you need to pay a sum of Rs.1000 only for conversion and you are not required to take a new connection for domestic use. But, in case you require a different ferrule size you have to pay charges assuming you had requested for new connection",
  },

  {
    question:
      "How would the fees be calculated for new connection in case of domestic use ?",
    answer:
      "Based on the ferrule size you would be required to pay connection fees. You would also be required to pay road restoration charges and road opening charges. Kindly refer to the following table. Ferrule Size Connection fee for domestic or other than I.C.I. connections (Rs.) 10 mm 1600 + Road restoration charges + Road opening charges 15 mm 2200 + Road restoration charges + Road opening charges 20 mm 4700 + Road restoration charges + Road opening charges 25 mm 6300 + Road restoration charges + Road opening charges.",
  },

  {
    question:
      "How would the fees be calculated for new connection for commercial, Industrial or Institutional use ?",
    answer:
      "Based on the ferrule size you would be required to pay connection fees. You would also be required to pay road restoration charges and road opening charges. Kindly refer to the following table. Ferrule Size Connection fee for I.C.I. connections (Rs.) 10 mm 5100 + Road restoration charges + Road opening charges 15 mm 7100 + Road restoration charges + Road opening charges 20 mm 8700 + Road restoration charges + Road opening charges 25 mm 11000 + Road restoration charges + Road opening charges",
  },

  {
    question:
      "What would be the monthly charges for commercial water supply at different Ferrule sizes ?",
    answer:
      "Based on the ferrule size you would be required to pay monthly charges in case you have an I.C.I. connection. Please refer to the following table. Ferrule Size Monthly Rate for Business / Non-Domestic Premises (Rs.)",
  },

  {
    question:
      "What would be charges for consumption of water through bulk meter be calculated?",
    answer: (
      <>
        The calculation of Bulk Water Charges is not based on a single
        parameter. The applicable charges are determined in accordance with the
        prevailing rules, regulations, and tariff structure of the Kolkata
        Municipal Corporation, taking into consideration the following factors:
        <ol type="1">
          <li>
            <strong>Size of the Ferrule</strong>: The diameter/size of the
            ferrule provided for the water connection is one of the primary
            determinants for calculating the applicable bulk water charges.
          </li>
          <li>
            <strong>Category of Consumer</strong>: The nature and category of
            the consumer served through the bulk water connection (such as
            residential, commercial, industrial, institutional, or any other
            applicable category) directly influence the assessment of the
            charges.
          </li>
          <li>
            <strong>Fixed Charges</strong>: The fixed component of the bulk
            water charge is determined based on the applicable tariff schedule
            and other prescribed conditions, which may vary depending upon the
            nature of the connection and other relevant criteria as approved by
            the competent authority.
          </li>
        </ol>
        Accordingly, the assessment of Bulk Water Charges is carried out after
        considering all the above factors in conformity with the provisions of
        the applicable KMC rules and tariff notifications. Any calculation or
        demand raised shall therefore be based on the prescribed methodology and
        the specific attributes of the concerned water connection.
      </>
    ),
  },

  {
    question:
      "How can I apply for reconnection of water supply or change of pipe or change of ferrule size ?",
    answer:
      "Kindly apply at the concerned Section office and pay the requisite fees.",
  },

  {
    question:
      "Whom should I contact for a water tanker and how much would it cost me ?",
    answer:
      "In order to get a water tanker in case of temporary shortage of water supply or on special occasions, kindly contact: Assistant Engineer (Mains), at H.P.L., 6, Convent Road, Ph: 2265-5785, 2265-5845. You would be required to pay Rs. 700 for residential purpose and Rs. 1000 for non-residential purpose of each tanker of 3600 litre capacity. This service is available between 8 a.m. to 6 p.m.",
  },

  {
    question:
      "Whom should I contact for installation of new tube-wells or repair of damaged tube-wells ?",
    answer:
      "Kindly contact the Executive Engineer, Tubewell, 5, S.N. Banerjee Road, Kolkata – 700 013, Phone: 2286-1100-08, Extension 2567",
  },

  {
    question:
      "What are my duties as a citizen with respect to water supply? What may happen if I fail to perform my duties ?",
    answer:
      "The following are the duties of citizen w.r.t water a. All the parts of the pipelines within each premises should be protected and taken proper care of, to prevent the flow of dirty underground water. If required, you may have to install a new pipeline in place of your old existing damaged one at your own cost with the permission of the Corporation. b. Lids of underground and overhead reservoirs should be properly covered and the water flow should be properly maintained so that there is no damage. At least once in a week water should be emptied and bleached to prevent them from becoming the breeding place of germs and mosquitoes. If you fail to perform your duties in either of cases then, KMC may decide to disconnect your water supply.",
  },

  {
    question:
      "What are the expected timelines of performance of the following activities ?",
    answer: (
      <ol type="a" className="pl-3">
        {[
          "Inspection of premises after application form is submitted at Section office  3 Days",
          "Issuance of demand notice after completion of inspection 3 Days",
          "Sanction Certificate for water connection after receipt of payment 1 Day",
          "Processing of application for reconnection of water supply 3 Days",
        ].map((item) => (
          <li>{item}</li>
        ))}
      </ol>
    ),
  },

  {
    question:
      "What should I do in case of an excessive delay in the approval of water supply connection ?",
    answer:
      "In the unlikely event of delay in approval kindly contact the Deputy Chief engineer, Water Supply at the KMC, Headquarters. Ph.No. 2286 -1100-08, Extn: 2573.",
  },

  {
    question:
      "Whom should I contact for non-supply of water or to lodge complaints for supply of unhygienic water ?",
    answer: (
      <>
        For non-supply of water, kindly contact the Assistant Engineer of the
        concerned office at your locality.
        <ol type="1">
          {[
            "Cossipur Section, 10, B.T. Road, Kolkata-2 Ph: 2558-8553, For Ward No: 1, 2, 3, 4, 5, 6",
            "Hatibagan Section, 79, Bidhan Sarani, Kol.- 6 Ph: 2543-1602,  For Ward No:  7, 8, 9, 10, 11, 12, 15",
            "Brindaban Bose Section, 28, Brindaban Bose Lane, Kolkata -6, For Ward No: 16, 17, 18, 19, 20",
            "B. K. Pal Section, 105, B. K. Pal Avenue, (Near the B.K. Pal Park), Kolkata- 700005,  For Ward No:  21, 22, 23, 24, 25",
            "Hedua Section, 6, Azad Hind Bagh, Hedua Square, Kolkata- 6, For Ward No:  26, 27, 28, 38, 39",
            "Section (Maniktala) 109, Narkeldanga Main Road, Kolkata- 11, Ph: 2364-9252, For Ward No:  13, 14, 29, 30, 31, 32, 33, 34, 35",
            "Section 'E' 1, Neel Madhab Sen Lane(Near Md. Ali Park), Kolkata-73, For Ward No:  41, 42, 43, 44, 45",
            "Section 'F' 22, Surya Sen Street, Kolkata-12, (Near Borough V office), Ph:2219 2399, For Ward No:  36, 37, 40, 48, 49, 50",
            "Section 'G', 23, Princep Street, Kolkata-700072, For Ward No: 46, 47, 51",
            "Section 'H' Hazi Md. Mohsin Square (Goltalab), Kolkata-16, For Ward No:  52, 53, 61, 62, 63",
            "Section 'I', 13, Dilkhusha Street (Near Park Circus Tram Depo), Kolkata- 700017, For Ward No:  64, 65",
            "Section 'J', P-65, Dr. Sundari Mohan Avenue, Kolkata-700014, For Ward No: 54, 55, 56, 57, 58, 59, 60",
            "Picnic Garden, 105/2, Prasanna Naskar Lane (Near Colony Bazar), Kolkata - 700039, Ph: 2334 -3900, For Ward No:  66, 67",
            "Section 'K', 212, Rashbehari Avenue (Gariahat Market, 3rd Floor), Kolkata- 700025, For Ward No:  68, 69, 72, 84, 85, 86, 87, 90",
            "Section 'L', 125, Hazra Road (At Hazra Road and Harish Mukherjee Road Crossing), ,Kolkata-700026 Ph: 2455 7978, For Ward No:  70, 71, 73, 74, 82, 83, 88",
            "Section 'M', 39, Circular Garden Reach Road (At Sudhir Bose Road and C.G.R.D. Road Junction), Kolkata-700024, For Ward No:  75, 76, 77, 78, 79, 80",
            "Section 'Tollygunge', Opposite Golf Green Daily Market, Uday Sankar Sarani, Kolkata-700045 Ph: 2483 6604, For Ward No:  81, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100.",
            "97 & 98, Garfa Main Road, Borough - XII Office, Kolkata - 700 075, For Ward No:  103, 104, 105, 106, 107, 108, 109",
            "Baghajatin Market Complex, Unit-III, Baghajatin Station Road, Kolkata - 700086, For Ward No:  101, 102, 110, 111, 112, 113, 114",
            "S.S. Unit, Behala, 516, D.H. Road, Borough-XIII and XIV Office, Kolkata - 700034, For Ward No:  115, 116, 117, 118, 119, 120, 121, 122, 127, 128, 129, 130, 131, 132",
            "G.R. Unit, E/3, Circular Garden Reach Road, Borough - XV Office, Kolkata - 700024, For Ward No:  133, 134, 135, 136, 137, 138, 139, 140, 141",
            "JOKA Unit, 4 Diamond Park, Br. XVI office, Kolkata - 700104 123, 124, 125, 126, 142, 143, 144",
          ].map((item) => (
            <li>{item}</li>
          ))}
        </ol>
      </>
    ),
  },

  {
    question:
      "How do we obtain permission for registration of existing and new power driver tubewells ?",
    answer:
      "All Account holders of the power driven tubewells within the KMC area are requested to collect the prescribed Form No.6 from the Tubewell Department, CMO Building, 2nd floor, 5, S N Banerjee Road, Kolkata 700013 for registration of their existing tubewell(s) under the provision of 'West Bengal Ground Water Resources (Management, Control and Regulation) Act, 2005'. For new power driven tubewell(s), permission should be obtained from State Water Investigation Directorate (SWID) and necessary license taken from Kolkata Municipal Corporation by depositing the requisite license fees. Address of SWID - Bikash Bhavan, 5th Floor, Kolkata 700 019.",
  },
];

const Water_Supply_Faqs = () => {
  return (
    <CommonPageUiLayer
      leftNavsList={WaterSupplyLeftNavsList}
      isLeftNavsListLong={true}
    >
      <div className="container">
        <div className="row">
          <div className="inner-title">
            <h3 className="fontSizeClass"> Water Supply : FAQs </h3>
          </div>

          <div className="col-lg-12 about-head1">
            <h4>Legal & Administrative Disclaimer</h4>
            <p className="fontSizeClass">
              The information contained herein is intended for administrative
              guidance, public awareness, and official reference purposes only.
              Any revision, amendment, or policy modification made by the
              competent authority after publication of this document shall
              prevail over the contents of this document.
            </p>
            <h4>Introduction</h4>
            <p className="fontSizeClass">
              The Water Supply Department of Kolkata Municipal Corporation is
              responsible for ensuring continuous and hygienic water supply
              throughout Kolkata. This document consolidates the Frequently
              Asked Questions (FAQs) related to water supply services,
              application procedures, charges, timelines, and citizen
              responsibilities.
            </p>
          </div>
          <AccordionComponent list={list} />
          <div className="col-lg-12 about-head1">
            <h4>Conclusion</h4>
            <p className="fontSizeClass">
              This document is intended to facilitate efficient public service
              delivery and ensure transparent communication regarding water
              supply-related matters. All concerned officials and citizens are
              advised to follow the prevailing rules, notifications, and
              directives issued by Kolkata Municipal Corporation from time to
              time.
            </p>
          </div>
        </div>
      </div>
    </CommonPageUiLayer>
  );
};

export default Water_Supply_Faqs;
